'use client';

import { active, option, optionA, optionB, switchStyle } from './switch.css';

type SwitchProps = {
  labels: [string, string];
  on: boolean;
  onChange: (on: boolean) => void;
  variant?: keyof typeof switchStyle;
  disabled?: boolean;
};

export default function Switch({
  labels,
  on,
  onChange,
  variant = 'default',
  disabled = false,
}: SwitchProps) {
  return (
    <div
      onClick={() => {
        if (!disabled) onChange(!on);
      }}
      className={switchStyle[variant]}
      style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <div className={[option[variant], optionA[variant], on && active].filter((c) => c).join(' ')}>
        <div style={{ pointerEvents: 'none' }}>{labels[0]}</div>
      </div>
      <div
        onClick={(e) => {
          e.stopPropagation();
          onChange(false);
        }}
        className={[option[variant], optionB[variant], !on && active].filter((c) => c).join(' ')}
      >
        <div style={{ pointerEvents: 'none' }}>{labels[1]}</div>
      </div>
    </div>
  );
}
